// Firebase App (the core Firebase SDK) is always required and must be listed first
import * as firebase from "firebase/app"

// Add the Firebase products that you want to use
import "firebase/auth"
import "firebase/firestore"
import 'firebase/storage'

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_GOOGLE_ACCOUNT_API_KEY,
  authDomain: "organizacion-lb.firebaseapp.com",
  databaseURL: "https://organizacion-lb.firebaseio.com",
  projectId: "organizacion-lb",
  storageBucket: "organizacion-lb.appspot.com",
  messagingSenderId: "111158348818",
  appId: "1:111158348818:web:783eb65686ca2830af9ccb"
}
// Initialize Firebase
firebase.initializeApp(firebaseConfig)

export const db  		 = firebase.firestore()
export const auth    = firebase.auth()
export const storage = firebase.storage